import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { InvoiceInfoFields } from "./HomeTypes";

export interface InvoiceBarProps {
  data?: InvoiceInfoFields[];
}
export const InvoiceBar = (props: InvoiceBarProps) => {

  const { data } = props

  const getOption = () => {
    let invoiceBarData = [[0, 0], [0, 0], [0, 0], [0, 0]];
    if (data != undefined && data.length > 0) {
      invoiceBarData = [
        [data?.[0].notInvoicedNum ?? 0, data?.[1].notInvoicedNum ?? 0],
        [data?.[0].invoicedNum ?? 0, data?.[1].invoicedNum ?? 0],
        [data?.[0].specialNum ?? 0, data?.[1].specialNum ?? 0],
        [data?.[0].ordinaryNum ?? 0, data?.[1].ordinaryNum ?? 0],
      ];
    }
    return {
      title: {
        text: '发票信息',
        textStyle: {
          fontSize: 21
        }
      },
      textStyle: {
        fontSize: 16
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        width: 500,
        top: 30,
        left: -5,
        textStyle: {
          fontSize: 16
        }
      },
      grid: {
        top: 100
      },
      xAxis: [
        {
          type: 'category',
          data: ['销售单', '维修单']
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '未开',
          type: 'bar',
          barWidth: 30,
          itemStyle: { color: '#7FBBFF' },
          data: invoiceBarData[0]
        },
        {
          name: '已开',
          type: 'bar',
          barWidth: 30,
          itemStyle: { color: '#0077FF' },
          data: invoiceBarData[1]
        },
        {
          name: '增值税专用发票',
          type: 'bar',
          barWidth: 30,
          itemStyle: { color: '#FEC410' },
          data: invoiceBarData[2]
        },
        {
          name: '增值税普通发票',
          type: 'bar',
          barWidth: 30,
          itemStyle: { color: '#FFE594' },
          data: invoiceBarData[3]
        }
      ]
    };
  }

  return (
    <ReactEchartsCore
      echarts={echarts}
      option={getOption() as echarts.EChartOption<echarts.EChartOption.Series>}
      style={{ height: '100%' }}
    />
  )
}